var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup_window"},[_c('div',{staticClass:"popup_inner"},[_c('div',{staticClass:"popup_close-btn is-absolute",on:{"click":_vm.onClose}}),_c('forgot',{on:{"onChnageTab":function($event){return _vm.$emit('onChnageTab', 'signin')}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }